import { render, staticRenderFns } from "./QuillWrapper.vue?vue&type=template&id=231b70e4&scoped=true&"
import script from "./QuillWrapper.vue?vue&type=script&lang=ts&"
export * from "./QuillWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./QuillWrapper.vue?vue&type=style&index=0&id=231b70e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b70e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
